import { ArrowLeft } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import { JobPostingForm } from '@/components/job-postings/JobPostingForm';
import { toast } from '@/lib/toast';
import { createJobPosting } from '@/services/jobPostingService';

import type { CreateJobPostingPayload } from '@/types/jobPosting.types';

export function JobPostingCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCreate = async (data: CreateJobPostingPayload, status?: 'draft' | 'active') => {
    setIsSubmitting(true);
    try {
      await createJobPosting({ ...data, status });
      toast.success(t('jobPostings.toasts.createSuccess'));
      void navigate('/job-postings');
    } catch {
      toast.error(t('jobPostings.toasts.error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className='space-y-6'>
      <div className='flex items-center gap-4'>
        <Link to='/job-postings' className='text-gray-500 hover:text-gray-700'>
          <ArrowLeft size={20} />
        </Link>
        <h1 className='text-2xl font-bold text-gray-900'>{t('jobPostings.createTitle')}</h1>
      </div>

      <div className='bg-white shadow rounded-lg p-6'>
        <JobPostingForm
          onSubmit={(data, status) => void handleCreate(data as CreateJobPostingPayload, status)}
          isSubmitting={isSubmitting}
        />
      </div>
    </div>
  );
}
